/* eslint sort-keys: "error" */
export default {
  appStoreBadgeClicked: 'app store badge clicked',
  arbitration: {
    arbSubmitClicked: 'arb submit clicked',
    categoryClicked: 'arb category clicked',
    complaintAdded: 'arb complaint added',
    complaintDeleted: 'arb complaint deleted',
    deleteComplaintClicked: 'arb delete complaint clicked',
    editComplaintClicked: 'arb edit complaint clicked',
    error: 'arb error occurred',
    evidenceAdded: 'arb evidence added',
    evidenceRemoved: 'arb evidence removed',
    evidenceUploadCompleted: 'arb evidence upload completed',
    odometerCancelClicked: 'arbitration odometer cancel clicked',
    odometerCompleted: 'arbitration odometer completed',
    odometerNextClicked: 'arbitration odometer next clicked',
    odometerStarted: 'arbitration odometer started',
    submitEvidenceClicked: 'arbitration submit evidence clicked',
    timelineUploadClicked: 'arbitration timeline upload clicked',
  },
  arbitrationPolicyViewed: 'arbitration policy viewed',
  arbitrationSubmitted: 'arb submitted',
  auctionAccess: {
    alerts: {
      dialogClosed: 'auction access account alerts dialog closed',
      dialogShown: 'auction access account alerts dialog shown',
      dialogSubmitted: 'auction access account alerts dialog submit button clicked',
    },
    dealershipSelection: {
      backButtonClicked: 'auction access dealership selection back button clicked',
      dealershipIssues: 'auction access dealership issues viewed',
      dealershipRegistrationBlockingIssuesFound: 'auction access registration blocking issues found',
      dealershipSelectedError: 'auction access dealership lead creation error',
      dealershipSelectedSuccess: 'auction access dealership lead creation success',
      dealershipsEligibleForRegistration: 'auction access dealerships eligible for registration found',
      viewed: 'auction access dealership selection viewed',
    },
    form: {
      backButtonClicked: 'auction access form back button clicked',
      formSubmittedError: 'auction access account information retrieval error',
      formSubmittedSuccess: 'auction access account information retrieval success',
      viewed: 'auction access form viewed',
    },
    preRegistration: {
      auctionAccessAccountRegistrationLinkClicked: 'auction access account registration link clicked',
      continueWithAuctionAccessClicked: 'auction access preregistration clicked',
      viewed: 'auction access preregistration viewed',
    },
    userAffiliationRegistration: {
      duplicateUser: 'duplicate user found, user auction access affiliation registration aborted',
      failure: 'user auction access affiliation registration failure',
      success: 'user auction access affiliation registration success',
    },
  },
  auctionHideChanged: 'auction hide changed',
  auctionHoldChanged: 'auction hold changed',
  auctionIssueScreenLoaded: 'Auction Issue Screen Loaded',
  auctionLaunched: 'auction launched',
  auctionLaunchedFailed: 'auction launched failed',
  auctionListUpdatedNotificationLinkClicked: 'auction list updated notification link clicked',
  auctionPurchasedNow: 'buy now auction purchased',
  auctionTitleStatusTracker: 'auction title status track package clicked',
  auctionViewed: 'auction viewed',
  audioPlaybackEnded: 'amp playback ended',
  audioPlaybackPaused: 'amp playback paused',
  audioPlaybackStarted: 'amp playback started',
  bidClicked: 'bid clicked',
  bidFailed: 'bid failed',
  bidPlaced: 'bid placed',
  bidWindowClosed: 'bid window closed',
  breadcrumbLinkClicked: 'breadcrumb link clicked',
  buyerNotesSaved: 'buyer notes saved',
  buyerNotesUpdated: 'buyer notes updated',
  buyerNotesViewed: 'buyer notes viewed',
  buyingSystemLinkClicked: 'buying system link clicked',
  buyingTabViewed: 'buying tab viewed',
  capital: {
    checkout: {
      advantageDisplayed: 'capital advantage checkout displayed',
      advantageProductSelection: 'capital advantage checkout product selection',
      advantageTCLink: 'capital advantage terms and conditions clicked',
      error: 'capital checkout error',
      floatToFloorDisplayed: 'capital float to floor checkout displayed',
      floatToFloorProductSelection: 'capital float to floor checkout product selection',
      floatToFloorTosClicked: 'capital float to floor tos link clicked',
      floorplanDisplayed: 'capital floorplan checkout displayed',
      floorplanProductSelection: 'capital floorplan checkout product selection',
      floorplanTermSelected: 'capital floorplan checkout term selected',
      floorplanTosClicked: 'capital floorplan tos link clicked',
      missingPaymentMethods: 'capital missing payment methods',
      reinforcementMessageCtaClicked: 'capital checkout reinforcement message cta clicked',
      reinforcementMessageDisplayed: 'capital checkout reinforcement message displayed',
      utilizationPresented: 'capital utilization message presented',
    },
    ineligibleVehicle: 'capital ineligible vehicle',
    landing: {
      salesRepURLAccessed: 'capital landing page URL accessed',
    },
    leadGen: 'capital lead gen presented',
    leadGenApiFailureError: 'capital lead gen api failure error msg',
    leadGenLearnMore: 'capital lead gen clicked learn more',
    leadGenRequestMore: 'capital lead gen clicked request more',
    leadGenTCErrorMsg: 'capital lead gen t&c error msg',
    openApplicationForm: 'capital application apply clicked',
    outOfRange: 'capital out of range',
    portal: {
      enterPortal: 'capital portal entered',
      errorPagePresented: 'capital portal error page presented',
      existsRetry: 'capital portal exists retry',
    },
  },
  carfax: {
    carfaxLoginTriggered: 'carfax login triggered',
    carfaxLogout: 'carfax logout',
    carfaxRedirectFailed: 'carfax redirect failed',
    carfaxRedirectSuccess: 'carfax redirect success',
    carfaxReportAuthError: 'carfax report auth error',
    carfaxReportAuthSuccess: 'carfax report auth success',
    carfaxReportNotFound: 'carfax report not found',
    carfaxReportPurchased: 'carfax report purchased',
    carfaxReportViewed: 'carfax viewed',
  },
  clearCarAppraisalLinkClicked: 'clearcar appraisal link clicked',
  clockDrift: 'clock drift',
  counterOfferSent: 'Counter offer sent',
  crPreviewOpened: 'cr preview opened',
  creditBannerInfoHover: 'credit banner info hover',
  dealerDocs: {
    registerDocumentClicked: 'register document upload clicked',
    registerDocumentFailed: 'register document failed',
    registerDocumentFormDownloaded: 'register document form downloaded',
    registerDocumentUploaded: 'register document uploaded',
  },
  dealerNetworkBidDetailsHovered: 'dealer network bid details hovered',
  deprecationBannerClicked: 'deprecation banner clicked',
  digicast: {
    pandaMfeLoadFailed: 'panda mfe load failed',
    pandaMfeLoadSuccess: 'panda mfe load success',
  },
  digitalRunSheet: {
    editClicked: 'request inspection edit clicked',
    failedValidation: 'request inspection validation failure',
    navigatedBack: 'request inspection back clicked',
    navigatedForward: 'request inspection next clicked',
    startedNewOrResumed: 'request inspection new clicked',
    startedOver: 'request inspection start over clicked',
    submitted: 'inspection request submitted',
    viewedSubmittedRequests: 'request inspection requested clicked',
  },
  dnsForm: {
    saveClicked: 'save dns form clicked',
  },
  endedAuctionPurchase: {
    acceptedOnCounterPage: 'buy now (ended auction purchase) price accepted on counter page',
    acceptedOnMakeOfferValidationAtCounterPage: 'buy now (ended auction purchase) price accepted on make offer validation at counter page',
    acceptedOnMakeOfferValidationAtSrpVdp: 'buy now (ended auction purchase) price accepted on make offer validation at srp, vdp',
    acceptedOnSrp: 'buy now (ended auction purchase) price accepted on srp',
    acceptedOnVdp: 'buy now (ended auction purchase) price accepted on vdp',
    createdOnNegotiationDeclineAtCounterPage: 'buy now (ended auction purchase) price created on negotiation decline at counter page',
    createdOnNegotiationDeclineAtVdp: 'buy now (ended auction purchase) price created on negotiation decline at vdp',
    createdOnOfferDeclineAtCounterPage: 'buy now (ended auction purchase) price created on offer decline at counter page',
    removedFromSavedPageVdp: 'buy now (ended auction purchase) price removed from saved page vdp',
    removedFromVdp: 'buy now (ended auction purchase) price removed from vdp',
    removedOnNegotiationDeclineAtCounterPage: 'buy now (ended auction purchase) price removed on negotiation decline at counter page',
    removedOnOfferDeclineAtCounterPage: 'buy now (ended auction purchase) price removed on offer decline at counter page',
  },
  featureFlagsUpdated: 'feature flags updated',
  filterCleared: 'filter cleared',
  filtersWindowOpened: 'Filters window opened',
  finalizeOptionsViewed: 'checkout page viewed',
  fleetLeaseBadgeClicked: 'fleet lease badge clicked',
  footer: {
    dealerFormsLinkClicked: 'footer dealer documents clicked',
    facebookClicked: 'footer facebook clicked',
    instagramClicked: 'footer instagram clicked',
    legalLinkClicked: 'footer legal clicked',
    linkedinClicked: 'footer linkedin clicked',
    privacyPolicyLinkClicked: 'footer privacy policy clicked',
    supportLinkClicked: 'footer support clicked',
    termsOfServiceLinkClicked: 'footer terms of service clicked',
    twitterClicked: 'footer twitter clicked',
  },
  forgotPasswordClicked: 'forgot password link clicked',
  forgotPasswordLoginClicked: 'forgot password return to login clicked',
  fullConditionReportViewed: 'full cr viewed',
  googlePlayStoreBadgeClicked: 'google play store badge clicked',
  googleRecaptchaRequestFailed: 'failed to obtain google recaptcha token',
  guarantee: {
    disclosureSubmitted: 'guarantee disclosure submitted',
    getGuaranteeClicked: 'get guarantee clicked',
    offerAccepted: 'guarantee offer accepted',
  },
  headerLinkClicked: 'header link clicked',
  jwtEmbed: {
    error: 'JWT wrapper for native error on initialization',
    logging: 'JWT wrapper for native debug logging',
  },
  loginClicked: 'log in clicked',
  loginFailed: 'log in failed',
  loginSuccess: 'logged in',
  makeOfferCancel: 'offer window closed',
  makeOfferConfirmCancel: 'Make offer confirm cancel clicked',
  makeOfferConfirmOk: 'Make offer confirm ok clicked',
  makeOfferFailed: 'make offer failed',
  makeOfferModalViewed: 'make offer modal viewed',
  makeOfferOk: 'make offer button clicked',
  makeOfferOpenClicked: 'make offer open clicked',
  makeOfferSortBy: 'make offer sort by',
  malformedRefreshToken: 'malformed refresh token found',
  manageProxySettingsClicked: 'manage proxy settings clicked',
  managedUsersAddedUser: 'user added',
  managedUsersUserAddFailed: 'user add attempted but failed',
  marketReportComparableOpened: 'market report auction clicked',
  marketReportFaqClicked: 'market report faq clicked',
  marketReportFilterChanged: 'market report filter changed',
  marketReportSearched: 'market report searched',
  marketReportTabViewed: 'market report tab viewed',
  marketReportViewed: 'market report viewed',
  marketing: {
    imageClicked: 'login marketing carousel image cta clicked',
    nextSlideNavigated: 'login marketing carousel next slide navigated',
    prevSlideNavigated: 'login marketing carousel previous slide navigated',
    quoteClicked: 'login marketing carousel quote cta clicked',
  },
  marketplaceV2: {
    auctionCardModeToggled: 'auction card mode toggled',
    auctionImpression: 'auction impression',
    auctionListingsSelected: 'auction listings selected',
    auctionsSearched: 'auctions searched',
    eulaAccepted: 'eula accepted',
    eulaBannerClicked: 'eula banner clicked',
    eulaBannerDismissed: 'eula banner dismissed',
    eulaDisplayed: 'eula displayed',
    eulaFailedToDisplay: 'eula failed to display',
    eulaIntercepted: 'eula intercepted',
    eulaRetryDisplayClicked: 'eula retry display clicked',
    fastActionPanelToggled: 'fast action panel toggled',
    listingTypeSelected: 'listing type selected',
    marketplaceTabViewed: 'marketplace tab viewed',
    nearReserveBadgeSeen: 'near reserve badge seen',
    oneBidAwayBadgeSeen: 'one bid away badge seen',
    reserveMetBadgeSeen: 'reserve met badge seen',
    saveFiltersButtonToSavedSearch: 'save filters button to saved search',
    savedSearchesActivated: 'saved searches activated',
    savedSearchesCreateNewClicked: 'saved searches create new clicked',
    savedSearchesDeactivated: 'saved searches deactivated',
    savedSearchesEditClicked: 'saved searches edit clicked',
    searchSaved: 'search saved',
    sendToAuctionOpened: 'Send to auction opened',
    srpClearAllSavedSearches: 'srp clear all saved searches',
    srpClearEventsButtonClicked: 'srp clear events button clicked',
    srpEulaAcceptClickedFromDirectory: 'srp eula accept clicked from directory',
    srpEulaDownloadClickedFromDirectory: 'srp eula download clicked from directory',
    srpEventsDirectoryClosed: 'srp events directory closed',
    srpEventsDirectoryViewed: 'srp events directory viewed',
    srpLaneClickedFromDirectory: 'srp lane clicked from directory',
    srpLaneEventVisibilityToggled: 'srp lane event visibility toggled',
    srpLaneToggled: 'srp lane toggled',
    srpSimulcastEventViewCanceled: 'srp simulcast event view canceled',
    srpSimulcastEventViewed: 'srp simulcast event viewed',
    srpSortCriteriaChanged: 'srp sort criteria changed',
    srpStatePillClicked: 'srp state pill clicked',
    vdp3ToggleChanged: 'vdp 3 toggle changed',
    vehicleDetailPageClosed: 'vehicle detail page closed',
    viewMarketReportBadgeClicked: 'view market report badge clicked',
    viewWonAuctionsClicked: 'view won auctions clicked',
    watchlistToggled: 'watchlist toggled',
  },
  myAcvDataExported: 'myacv data exported',
  myAcvExportDataOpened: 'myacv export data opened',
  myAcvFinalized: {
    myAcvSoldFinalizedDealershipLicense: 'my acv sold finalized dealership license downloaded',
    myAcvSoldFinalizedResaleCertificate: 'my acv sold resale certificate license downloaded',
  },
  myAcvGsalePerformanceDashboard: {
    dataExportClicked: 'gsale performance dashboard data export clicked',
    dataExported: 'gsale performance dashboard data exported',
    viewed: 'gsale performance dashboard viewed',
  },
  myAcvOffers: {
    myAcvOffersAcceptFailed: 'myacv offers offer accept failed',
    myAcvOffersDealerFilterSelectedAll: 'myacv_offers_dealer_filter_selected_all',
    myAcvOffersDeclineFailed: 'myacv offers offer decline failed',
    myAcvOffersFiltersApplied: 'myacv offers filters applied',
    myAcvOffersGsaleFirmOfferViewed: 'myacv offers gsale firm offer viewed',
    myAcvOffersListViewSelected: 'offers_and_negotiations_list_view_selected',
    myAcvOffersNegotiationAcceptConfirmClicked: 'myacv offers negotiation accept confirm clicked',
    myAcvOffersNegotiationAcceptFailed: 'myacv offers negotiation accept failed',
    myAcvOffersNegotiationCounterConfirmClicked: 'myacv offers negotiation counter confirm clicked',
    myAcvOffersNegotiationCounterFailed: 'myacv offers negotiation counter failed',
    myAcvOffersNegotiationDeclineConfirmClicked: 'myacv offers negotiation decline confirm clicked',
    myAcvOffersNegotiationDeclineFailed: 'myacv offers negotiation decline failed',
    myAcvOffersNegotiationViewed: 'myacv offers negotiation viewed',
    myAcvOffersOfferAcceptCancelClicked: 'myacv offers offer accept cancel clicked',
    myAcvOffersOfferAcceptClicked: 'myacv offers offer accept clicked',
    myAcvOffersOfferAcceptConfirmClicked: 'myacv offers offer accept confirm clicked',
    myAcvOffersOfferAcceptFailed: 'myacv offers offer accept failed',
    myAcvOffersOfferDeclineCancelClicked: 'myacv offers offer decline cancel clicked',
    myAcvOffersOfferDeclineClicked: 'myacv offers offer decline clicked',
    myAcvOffersOfferDeclineConfirmClicked: 'myacv offers offer decline confirm clicked',
    myAcvOffersOfferDeclineFailed: 'myacv offers offer decline failed',
    myAcvOffersOfferViewed: 'myacv offers offer viewed',
    myAcvOffersPageChanged: 'myacv offers page changed',
    myAcvOffersRowClicked: 'myacv offers row clicked',
    myAcvOffersRowsPerPageChanged: 'myacv offers rows per page changed',
    myAcvOffersSearched: 'myacv offers searched',
    myAcvOffersTileViewSelected: 'offers_and_negotiations_tile_view_selected',
    myAcvOffersVinCopied: 'myacv offers vin copied',
  },
  myAcvSellerDashboard: {
    dealershipSelected: 'myacv seller dashboard dealership selected',
    graphHover: 'myacv seller dashboard graph hover',
    infoHover: 'myacv seller dashboard info hover',
    insightsDateChanged: 'myacv seller dashboard insights date change',
    titleComplianceToggle: 'myacv seller dashboard title toggle',
  },
  myAcvTabViewed: 'myacv tab viewed',
  myAcvWonDetails: {
    arbitrationStartClicked: 'arbitration claim started',
    arbitrationSubmitted: 'arbitration claim submitted',
    arbitrationTabClicked: 'my acv won arbitration clicked',
    arbitrationViewPolicy: 'acv arbitration policy viewed',
    reportedProblem: 'my acv won report a problem submitted',
    titleTabClicked: 'my acv won title clicked',
    transportCTABannerClicked: 'my acv won transport off platform cta clicked',
    transportCTABannerSeen: 'my acv won transport off platform cta seen',
    transportationTabClicked: 'my acv won transportation clicked',
  },
  myAcvWonTable: {
    arbitrationClaimStarted: 'Arbitration Claim Started',
    arbitrationTabClicked: 'Arbitration Tab Clicked',
    finalizeButtonClicked: 'my acv won finalized clicked',
    optionMenuClicked: 'my acv won option clicked',
    optionMenuItemSelected: 'my acv won option selected',
    titleClicked: 'my acv won title clicked',
    transportOffPlatformCtaClicked: 'MyACV Won: transportation offplatform cta clicked',
    transportOffPlatformCtaSeen: 'MyACV Won: transportation offplatform cta seen',
    transportationTabClicked: 'MyACV - Won : transportation subtab clicked',
    vehicleClicked: 'my acv won vehicle clicked',
  },
  myAcvWonTableV2: {
    bannerDismissClicked: 'my acv won finalize banner dismissed',
    downloadBillOfSaleClicked: 'my acv won download bill of sale clicked',
    finalizeButtonClicked: 'my acv won finalize auction clicked',
    finalizedAuctionSubmitted: 'my acv won finalize auction submitted',
    optionMenuItemSelected: 'my acv won option selected',
    pendingFinalizationTabClicked: 'my acv won finalize auction tab clicked',
    vehicleClicked: 'my acv won vehicle clicked',
    vehicleStatusesTabClicked: 'my acv won vehicle statuses tab clicked',
    viewedDetailsClicked: 'my acv won view details clicked',
    viewedOriginalListingClicked: 'my acv won view original listing clicked',
  },
  myInventory: {
    csvUploaded: 'my inventory csv uploaded',
    dataExported: 'my inventory data exported',
    expiredCRhidden: 'my inventory expired cr hidden',
    gsale: {
      firmOfferViewed: 'my inventory gsale firm offer viewed',
      requestPricing: 'my inventory gsale request pricing',
      sendToGsale: 'my inventory gsale send to gsale',
      submitToGsale: 'my inventory gsale submit to gsale',
      updatePricing: 'my inventory gsale update pricing',
      vehicleDisclosureSubmitted: 'my inventory gsale vehicle disclosure submitted',
    },
    inspectionRequest: {
      requestSent: 'my inventory inspection request sent',
    },
    launchVehiclesClicked: 'my inventory launch vehicles clicked',
    mfeLoadFailed: 'my inventory mfe load failed',
    mfeLoadSuccess: 'my inventory mfe load success',
    statusCtaClicked: 'my inventory status clicked',
    statusFiltered: 'my inventory status filtered',
    tableReordered: 'my inventory table reordered',
    viewTypeSwitched: 'my inventory view type switched',
  },
  noNetworkDialogShown: 'No network dialog shown',
  notifications: {
    appLaunchMessageCtaClicked: 'notification app launch message url clicked',
    appLaunchMessageNextNavigated: 'notification app launch message next slide navigated',
    appLaunchMessagePrevNavigated: 'notification app launch message prev slide navigated',
    iconClicked: 'notification icon clicked',
    itemClicked: 'notification item clicked',
    markAllReadClicked: 'notification mark all as read clicked',
    pushNotificationClicked: 'push notification clicked',
    viewAllClicked: 'notification view all clicked',
  },
  offboarding: {
    deactivateAccountClicked: 'deactivate account clicked',
    deactivateAccountConfirmationClicked: 'deactivate account confirmation clicked',
    deactivateAccountReasonClicked: 'deactivate account reason clicked',
    dealershipWinbackActionClicked: 'deactivate account winback support clicked',
    notificationWinbackActionClicked: 'deactivate account winback notification clicked',
  },
  offerAttempt: 'offer attempt failed',
  offerMade: 'offer made',
  opened: 'app opened',
  otherIssuesSubmitted: 'other issues submitted',
  passwordResetRequested: 'requested password reset',
  paymentCompleted: 'payment completed',
  persistentProxy: {
    persistentProxyCreated: 'persistent proxy created via offer',
    persistentProxyToggled: 'persistent proxy checkbox toggled',
    persistentProxyUpdated: 'persistent proxy updated via offer',
  },
  photoCategoryClicked: 'photo category clicked',
  photoGalleryDuration: 'time in photo viewer',
  photoGalleryImagesViewed: 'num photos viewed',
  photoGalleryOpened: 'photo viewer opened',
  photoViewed: 'photo viewed',
  premiumPackagesViewed: 'premium packages viewed',
  pricingAdvisor: {
    launchingPrevented: 'launching prevented',
    pricingReviewSeen: 'acv pricing review seen',
  },
  proxyCanceled: 'proxy canceled',
  proxyEdited: 'proxy edited',
  proxyScheduleClicked: 'proxy schedule clicked',
  proxyScheduleWindowClosed: 'proxy schedule window closed',
  proxyScheduled: 'proxy scheduled',
  registration: {
    accountCreation: {
      duplicateUserError: 'registration account creation duplicate user error',
      formSubmittedSuccess: 'registration account creation success',
      unauthorizedError: 'registration account creation unauthorized error',
      unexpectedError: 'registration account creation unexpected error',
    },
    bankAccount: {
      accountAdded: 'registration bank account added',
      continueError: 'registration bank account continue error',
      continueSuccess: 'registration bank account continue success',
      fetchError: 'registration bank account fetch error',
      viewed: 'registration bank account viewed',
    },
    dealerForm: {
      formSubmittedError: 'registration dealer info form submission error',
      formSubmittedSuccess: 'registration dealer info form submission success',
      viewed: 'registration dealer info form viewed',
    },
    dealershipSelection: {
      backButtonClicked: 'registration dealership selection back button clicked',
      dealershipIssues: 'registration dealership issues viewed',
      dealershipRegistrationBlockingIssuesFound: 'registration blocking issues found',
      dealershipSelectedError: 'registration dealership lead creation error',
      dealershipSelectedSuccess: 'registration dealership lead creation success',
      dealershipsEligibleForRegistration: 'registration dealerships eligible for registration found',
      viewed: 'registration dealership selection viewed',
    },
    emailVerification: {
      blockingIssuesFound: 'registration email verification blocking issues found',
      codeExpired: 'registration email verification code expired',
      codeVerifiedSuccess: 'registration email verification code verified success',
      incorrectCodeEntered: 'registration email verification incorrect code entered',
      resendCodeClicked: 'registration email verification resend code clicked',
      resendCodeRateLimited: 'registration email verification resend code rate limited',
      resendCodeSuccess: 'registration email verification resend code success',
      unexpectedError: 'registration email verification unexpected error',
      viewed: 'registration email verification viewed',
    },
    form: {
      backButtonClicked: 'registration form back button clicked',
      blockingIssuesFound: 'registration form blocking issues found',
      formSubmittedError: 'registration account information retrieval error',
      formSubmittedSuccess: 'registration account information retrieval success',
      viewed: 'registration form viewed',
    },
    preRegistration: {
      accountRegistrationLinkClicked: 'registration account registration link clicked',
      continueWithRegistrationClicked: 'registration preregistration clicked',
      viewed: 'registration preregistration viewed',
    },
    userAffiliationRegistration: {
      duplicateUser: 'registration duplicate user found, user affiliation aborted',
      failure: 'registration user affiliation failure',
      success: 'registration user affiliation success',
    },
  },
  reportAProblemClicked: 'report a problem clicked',
  resetPasswordClicked: 'reset password button clicked',
  resetPasswordSuccessAndRedirect: 'reset password successful and redirected',
  rewardsButtonClicked: 'loyalty dealer rewards program button clicked',
  rewardsEnrollBtnClicked: 'loyalty join for free button clicked',
  rewardsEnrolled: 'loyalty enrollment completed',
  rewardsLoyaltyProgressViewed: 'loyalty rewards progress card viewed',
  rewardsPageViewed: 'loyalty dealer rewards program page viewed',
  savedAuctionDeleted: 'saved auction deleted',
  savedAuctions: {
    gsale: {
      firmOfferViewed: 'saved gsale firm offer viewed',
      offerFirstShown: 'gsale auction viewed',
    },
  },
  savedSearch: {
    conditionExclusionClicked: 'clicked condition exclusion',
    conditionExclusionViewed: 'viewed condition exclusion',
    conditionFilterClicked: 'clicked condition filter',
    matchNotificationForecastUpdateViewed: 'viewed notification forecast update',
    samBuyingRuleClicked: 'clicked SAM buying rule',
    samBuyingRuleViewed: 'viewed SAM buying rule',
    vehicleFilterClicked: 'clicked vehicle filters',
    vehicleFilterViewed: 'viewed vehicle filters',
  },
  scheduledAuctionCancelFailed: 'scheduled auction cancel failed',
  scheduledAuctionCanceled: 'scheduled auction canceled',
  sellerControlRoom: {
    scrLoadFailed: 'seller control room load failed',
    scrLoadSuccess: 'seller control room load success',
  },
  sellingTabViewed: 'selling tab viewed',
  serviceWorker: {
    existsToUpdateApp: 'Service worker exists to update app',
    forceReloadOnRouteChangeTriggered: 'Service worker force reload on route change triggered',
    initializationFailed: 'Service Worker Initialization Failed',
    registrationError: 'Service worker registration error',
    reloadingAutomatically: 'Service worker reloading automatically',
    skippedWaiting: 'Service worker is going to trigger skip waiting',
  },
  settings: {
    dealershipAddresses: {
      addNewFailure: 'dealership address creation attempted but failed',
      addNewSuccess: 'dealership address added successfully',
      dealershipSelected: 'dealership selected',
      deleteFailure: 'dealership address deletion attempted but failed',
      deleteSuccess: 'dealership address deleted successfully',
      filtersSelected: 'dealership address filters selected',
      paginationNavigated: 'dealership address pagination navigated',
      prepopulateAllDaysClicked: 'dealership address prepopulate all timeslots clicked',
      prepopulateDismissed: 'dealership address prepopulate timeslots dismissed',
      prepopulateWeekdaysClicked: 'dealership address prepopulate weekday timeslots clicked',
      searchCriteriaApplied: 'dealership address search criteria applied',
      updateFailure: 'dealership address update attempted but failed',
      updateSuccess: 'dealership address updated successfully',
    },
    dealershipContacts: {
      addNewFailure: 'dealership contact creation attempted but failed',
      addNewSuccess: 'dealership contact added successfully',
    },
    manageUsers: {
      deleteFailure: 'user deletion attempted but failed',
      deleteSuccess: 'user deleted successfully',
      passwordResetFailure: 'user password reset attempted but failed',
      passwordResetSuccess: 'user password reset successfully',

    },
    pageViewed: 'settings page viewed',
    settingChanged: 'setting changed',
  },
  shareCopyClicked: 'share copy clicked',
  signUpLinkClicked: 'registration sign up link clicked',
  sortEndedList: 'sort ended list',
  startAnArbClicked: 'start an arb clicked',
  tabLinkClicked: 'tab link clicked',
  titleHub: {
    chatRequested: 'chat requested',
    chatWidgetOpened: 'chat widget opened',
    titleAddNoteButtonClicked: 'title add note button clicked',
    titleBillOfSalesCilicked: 'title download bill of sales clicked',
    titleDownloadClicked: 'title download clicked',
    titleHubAllTitlesAddedToShipment: 'title hub all titles added to shipment',
    titleHubLabelPrinted: 'title hub label printed',
    titleHubShipmentExceptionRequested: 'title hub shipment exception requested',
    titleHubShipmentFinalized: 'title hub shipment finalized',
    titleHubShipmentQueueToggled: 'title hub shipment queue toggled',
    titleHubTitleAddedToShipment: 'title hub title added to shipment',
    titleHubTitleRemovedFromShipment: 'title hub title removed from shipment',
    titleNoteAdded: 'title note added',
    titleNoteCanceled: 'title note canceled',
    titleOptionClicked: 'title option clicked',
    titleTrackPackageClicked: 'title track package clicked',
    titleUploadCanceled: 'title upload canceled',
    titleUploadDocumentClicked: 'title upload document button clicked',
    titleUploadFileBrowsed: 'title upload file browsed',
    titleUploadFileDeleted: 'title upload file deleted',
    titleUploadSubmitted: 'title upload submitted',
    titleVehicleImageClosed: 'title vehicle image closed',
    titleVehicleImageOpened: 'title vehicle image opened',
    titleViewDetailsClicked: 'title view details clicked',
    titlesClosedStatusViewed: 'title status closed page viewed',
    titlesConfirmAndGenerateShippingLabelButtonClicked: 'title confirm and generate shipping label button clicked',
    titlesExportModalOpened: 'title export modal opened',
    titlesGenerateShippingLabelButtonClicked: 'title generate shipping label button clicked',
    titlesHeaderClicked: 'title logo header clicked',
    titlesHubOpened: 'titles hub clicked and viewed',
    titlesOpenStatusViewed: 'title status opened page viewed',
    titlesPreSaleStatusViewed: 'title status pre sale page viewed',
    titlesShippingLabelCreated: 'title shipping label created',
    titlesShippingLabelFailed: 'title shipping label failed to generate',
  },
  titleNoticeSubmitted: '48 hour title notice submitted',
  titleProblemSubmitted: 'title problem submitted',
  titleStatusSubmitted: 'title status submitted',
  transportCheckoutAddressSelected: 'transport checkout address selected',
  transportCheckoutLearnMoreClicked: 'transport checkout learn more clicked',
  transportOptionSelected: 'transport option selected',
  transportationHub: {
    transportationHubGatePassDeleteFileClicked: 'When a user clicks to delete gate pass',
    transportationHubGatePassDownloadButtonClicked: 'When a user clicks to download a gate pass',
    transportationHubGatePassUploadFileClicked: 'When a user clicks to add a new gate pass',
    transportationHubGetMyQuoteNowClicked: 'transportation hub get my quote now clicked',
    transportationHubGetMyQuoteNowVinEntered: 'transportation hub get my quote now vin entered',
    transportationHubGetQuoteBackClicked: 'transportation hub get quote back clicked',
    transportationHubGetQuoteDealerDropdownChanged: 'transportation hub get quote dealer dropdown changed',
    transportationHubGetQuoteDeliveryZipEntered: 'transportation hub get quote delivery zip entered',
    transportationHubGetQuotePickupZipEntered: 'transportation hub get quote pickup zip entered',
    transportationHubGetQuoteXClicked: 'transportation hub get quote x clicked',
    transportationHubMobileBannerGetQuoteClicked: 'transportation hub mobile banner 01 get quote clicked',
    transportationHubOrderDetailsViewed: 'transportation hub order details viewed',
    transportationHubOrdersSearched: 'transportation hub orders searched',
    transportationHubPaginated: 'transportation hub paginated',
    transportationHubPlaceOrderClicked: 'transportation hub place order clicked',
    transportationHubReviewOrderClicked: 'transportation hub review order clicked',
    transportationHubRowsPerPageChanged: 'transportation hub rows per page changed',
    transportationHubSortOrderChanged: 'transportation hub sort order changed',
    transportationHubStartANewOrderClicked: 'transportation hub start a new order clicked',
    transportationHubStatusFilterChanged: 'transportation hub status filter changed',
    transportationHubVerticalRightSideGetQuoteClicked: 'transportation hub vertical right side banner 01 get quote clicked',
    transportationHubViewed: 'transportation hub viewed',
    transportationRefreshPromptShowed: 'transportation hub show refresh prompt',
    transportationRemoteAppFailedToLoad: 'transportation hub remote app failed to load',
  },
  transportationStatusViewed: 'transportation status viewed',
  unwindArbitrationPlanPolicyViewed: 'unwind arbitration plan policy viewed',
  userMenuSelected: 'user menu selected',
  vinCopyClicked: 'vin copy clicked',
  virtualLiftClosed: 'virtual lift closed',
  virtualLiftExpanded: 'virtual lift expanded',
};
